import axiosInstance from './axiosInstance';

const posterService = {
  list: (params = {}) =>
    axiosInstance.get('/admin/posters', { params }),

  getById: (id) =>
    axiosInstance.get(`/admin/posters/${id}`),

  create: (data) =>
    axiosInstance.post('/admin/posters', data),

  update: (id, data) =>
    axiosInstance.put(`/admin/posters/${id}`, data),

  remove: (id) =>
    axiosInstance.delete(`/admin/posters/${id}`),
};

export default posterService;
